// extracted by mini-css-extract-plugin
export default {"root":"_2Z45E","first-row":"_2uWFV","firstRow":"_2uWFV","second-row":"L1zVz","secondRow":"L1zVz"};